/**
 * Angular requires Zone.js to enable async operations in the browser.
 * The CLI includes this polyfill automatically.
 */
import 'zone.js';
